import React from "react";

export default function LogoCloud({ title = "Trusted by teams", logos = [] }) {
  if (!logos.length) return null;

  return (
    <section className="eb-section">
      <div className="eb-container">
        <div className="flex items-center justify-between gap-6 flex-wrap">
          <h2 className="text-sm font-semibold text-slate-700">{title}</h2>
          <div className="h-px flex-1 bg-slate-200/70" />
        </div>

        <div className="mt-8 grid grid-cols-2 items-center gap-8 sm:grid-cols-3 lg:grid-cols-6">
          {logos.map((logo) => (
            <div key={logo.src} className="flex items-center justify-center">
              <img
                src={logo.src}
                alt={logo.alt ?? "logo"}
                className="max-h-16 w-auto object-contain opacity-100 "
                loading="lazy"
                decoding="async"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

